import React, { useEffect, useState } from 'react';

const CELEBRATION_LINES = {
  task: [
    "Yay! One down 🎉",
    "Boom! Crushed it 💪",
    "You're on fire! 🔥",
    "Task slayed ⚔️",
    "Proud of you 🥹",
    "Keep that momentum! ✨",
    "Nailed it! 🌟",
    "Wooohoo! 🎊",
  ],
  focus: [
    "Focus mode: legendary 🧠✨",
    "That's some deep work! 💫",
    "Brain gains unlocked 🚀",
    "What a session! 🌈",
  ],
  streak: [
    "STREAK LEVEL UP! 🔥🔥",
    "Look at you go! 💖",
    "Unstoppable! 🦸",
  ],
};

function pickLine(kind) {
  const arr = CELEBRATION_LINES[kind] || CELEBRATION_LINES.task;
  return arr[Math.floor(Math.random() * arr.length)];
}

export default function PetCelebration({ trigger, kind = 'task' }) {
  const [visible, setVisible] = useState(false);
  const [line, setLine] = useState('');
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (trigger > 0) {
      setLine(pickLine(kind));
      setVisible(true);
      setKey((k) => k + 1);
      const t = setTimeout(() => setVisible(false), 2400);
      return () => clearTimeout(t);
    }
  }, [trigger, kind]);

  if (!visible) return null;

  const sparkles = Array.from({ length: 8 }, (_, i) => i);

  return (
    <div
      key={key}
      className="pointer-events-none absolute inset-0 z-50 flex flex-col items-center"
      data-testid="pet-celebration"
    >
      {/* Speech bubble */}
      <div
        className="relative mx-auto mb-1 rounded-2xl border-2 border-black bg-white px-3 py-1.5 text-xs font-bold shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] animate-bounce-in"
        style={{ background: 'linear-gradient(135deg, #FFE8A3 0%, #FFC8DD 100%)' }}
      >
        {line}
        <span
          className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0"
          style={{ borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: '8px solid #000' }}
        />
      </div>
      {/* Sparkle burst */}
      <div className="relative w-24 h-24">
        {sparkles.map((i) => {
          const angle = (i / sparkles.length) * 360;
          const delay = (i % 4) * 0.05;
          return (
            <span
              key={i}
              className="absolute left-1/2 top-1/2 text-lg"
              style={{
                transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-40px)`,
                animation: `sparkle-burst 0.9s ease-out ${delay}s forwards`,
                opacity: 0,
              }}
            >
              {i % 3 === 0 ? '✨' : i % 3 === 1 ? '⭐' : '💫'}
            </span>
          );
        })}
      </div>
    </div>
  );
}
